const getRedirectsFromTreeViewItems = (treeViewItems, redirects) =>
  treeViewItems.reduce((acc, { id }) => [...acc, redirects[id]], []);

export default getRedirectsFromTreeViewItems;
